export enum DurationUnit {
  SECONDS = 'SECONDS',
  MILLISECONDS = 'MILLISECONDS',
  HOURS = 'HOURS',
  MINUTES = 'MINUTES',
  DAYS = 'DAYS'
}
